import { useCallback, useEffect, useRef } from "react";

export default function useInterval(callback: any, timeout: number): void {
  const savedCallback = useRef(callback);

  const handler = useCallback(() => {
    savedCallback.current(new Date().getTime());
  }, []);

  // Store latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up/teardown the interval
  useEffect(() => {
    if (timeout != null) {
      const id = window.setInterval(handler, timeout);
      return () => {
        window.clearInterval(id);
      };
    }
  }, [handler, timeout]);
}
